/* ambrée — thème Shopify */
(function () {
  'use strict';
  const A = window.ambree || { routes: {}, text: {} };
  const T = A.text;
  const RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  /* ---------- Prix ---------- */
  function money(cents) {
    const fmt = A.moneyFormat || 'CHF {{amount}}';
    const v = (cents || 0) / 100;
    const sep = (n, t, d) => { const [i, f] = n.toFixed(2).split('.'); return i.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (d ? d + f : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      if (k === 'amount_no_decimals') return sep(v, ',', '').replace(/\..*/, '');
      if (k === 'amount_with_comma_separator') return sep(v, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return sep(v, "'", '.');
      if (k === 'amount_no_decimals_with_comma_separator') return sep(v, '.', '');
      return sep(v, ',', '.');
    });
  }

  /* ---------- Toast ---------- */
  let tt;
  function toast(m) { const t = $('#toast'); if (!t) return; t.textContent = m; t.classList.add('show'); clearTimeout(tt); tt = setTimeout(() => t.classList.remove('show'), 2200); }

  /* ---------- En-tête et menu ---------- */
  const head = $('#head');
  function onScroll() { if (head) head.classList.toggle('over', document.body.classList.contains('home') && window.scrollY < window.innerHeight * 0.6); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Panier latéral ---------- */
  const drawer = $('#cart'), scrim = $('#scrim');
  function openCart() { if (!drawer) return; drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); scrim.classList.add('open'); $('#closeCart').focus(); }
  function closeCart() { if (!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); scrim.classList.remove('open'); }

  async function getCart() { const r = await fetch(A.routes.cart + '.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function changeLine(key, quantity) {
    const r = await fetch(A.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
    return r.json();
  }
  function renderCart(cart) {
    const n = cart.item_count;
    const c = $('#count'); if (c) { c.textContent = n; c.hidden = !n; }
    const open = $('#openCart'); if (open) open.setAttribute('aria-label', `Ouvrir le panier, ${n} article${n > 1 ? 's' : ''}`);
    const ship = $('#ship');
    const free = Number(A.freeShipping || 0) * 100;
    if (ship) {
      if (free > 0) { ship.hidden = false; ship.textContent = cart.total_price >= free ? T.freeDone : T.freeLeft.replace('[montant]', money(free - cart.total_price)); }
      else ship.hidden = true;
    }
    const cb = $('#cb'), cf = $('#cf'); if (!cb) return;
    if (!n) { cb.innerHTML = `<div class="empty"><span>${T.empty}</span><a class="btn" href="${A.routes.root}collections/all">${T.discover}</a></div>`; cf.innerHTML = ''; return; }
    cb.innerHTML = cart.items.map(i => `
      <div class="li">
        <div class="ph">${i.image ? `<img src="${i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=300'}" alt="" loading="lazy">` : ''}</div>
        <div><b><a href="${i.url}">${esc(i.product_title)}</a></b>${i.product_has_only_default_variant ? '' : `<small>${esc(i.variant_title)}</small>`}
          <div class="q"><button data-dec="${i.key}" data-q="${i.quantity}" aria-label="Diminuer la quantité">−</button><span>${i.quantity}</span><button data-inc="${i.key}" data-q="${i.quantity}" aria-label="Augmenter la quantité">+</button></div>
          <button class="rm" data-rm="${i.key}">${T.remove}</button></div>
        <div style="font-size:14px">${money(i.final_line_price)}</div>
      </div>`).join('');
    cf.innerHTML = `<div class="tot"><span>${T.subtotal}</span><span>${money(cart.total_price)}</span></div><a class="btn full" href="${A.routes.root}checkout">${T.checkout}</a>`;
  }
  async function refreshCart() { try { renderCart(await getCart()); } catch (e) { /* hors ligne */ } }

  /* ---------- Fiche produit : variantes et ajout ---------- */
  function initProduct() {
    const form = $('#product-form'); if (!form) return;
    const dataEl = $('[data-product-json]'); if (!dataEl) return;
    const data = JSON.parse(dataEl.textContent);
    const idInput = $('[data-variant-id]', form), addBtn = $('[data-add]', form), priceEl = $('[data-price]'), errEl = $('[data-error]', form);
    const selected = () => data.options.map((_, i) => { const c = $(`input[data-option="${i}"]:checked`, form); return c ? c.value : null; });
    const gallery = $('[data-product-gallery]');
    const galleryNote = $('[data-gallery-note]');
    let galleryKey = null;
    function updateGallery(variant) {
      if (!gallery) return;
      const media = (data.media || []).filter(item => item.media_type === 'image');
      const featured = variant.featured_media;
      const selectedMedia = featured && media.find(item => item.id === featured.id);
      const key = selectedMedia ? (selectedMedia.alt || String(selectedMedia.id)) : 'unassigned';
      if (galleryNote) galleryNote.hidden = !!selectedMedia || data.variants.length === 1;
      if (key === galleryKey) return;
      galleryKey = key;
      let images = selectedMedia && selectedMedia.alt ? media.filter(item => item.alt === selectedMedia.alt) : selectedMedia ? [selectedMedia] : media.slice(0, 6);
      if (selectedMedia) images = [selectedMedia, ...images.filter(item => item.id !== selectedMedia.id)];
      const fragment = document.createDocumentFragment();
      images.forEach((item, index) => {
        const preview = item.preview_image;
        if (!preview || !preview.src) return;
        const frame = document.createElement('div');
        frame.className = 'ph';
        frame.dataset.mediaId = item.id;
        const img = document.createElement('img');
        const src = new URL(preview.src, location.origin);
        src.searchParams.set('width', '1800');
        img.src = src.href;
        img.srcset = [600, 900, 1200, 1800].map(width => { const sized = new URL(src); sized.searchParams.set('width', String(width)); return sized.href + ' ' + width + 'w'; }).join(', ');
        img.sizes = '(min-width: 900px) 30vw, 86vw';
        img.alt = item.alt || data.title || '';
        img.loading = index ? 'lazy' : 'eager';
        img.fetchPriority = index ? 'auto' : 'high';
        if (preview.width) img.width = preview.width;
        if (preview.height) img.height = preview.height;
        frame.appendChild(img);
        fragment.appendChild(frame);
      });
      if (fragment.childElementCount) {
        gallery.replaceChildren(fragment);
        gallery.classList.toggle('one', gallery.childElementCount < 2);
        gallery.scrollLeft = 0;
      }
    }
    function update() {
      const sel = selected();
      sel.forEach((v, i) => { const s = $(`[data-selected="${i}"]`); if (s) s.textContent = v || ''; });
      const v = data.variants.find(x => x.options.every((o, i) => o === sel[i]));
      // marquer les valeurs indisponibles
      data.options.forEach((_, oi) => $$(`input[data-option="${oi}"]`, form).forEach(inp => {
        const test = sel.slice(); test[oi] = inp.value;
        const ok = data.variants.some(x => x.available && x.options.every((o, i) => o === test[i]));
        inp.classList.toggle('na', !ok);
      }));
      if (!v) { addBtn.disabled = true; addBtn.textContent = T.chooseSize; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addBtn.textContent = v.available ? T.add : T.soldOut;
      if (priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? `<span class="compare">${money(v.compare_at_price)}</span>` : '');
      updateGallery(v);
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    form.addEventListener('change', e => { if (e.target.matches('[data-option]')) update(); });
    form.addEventListener('submit', async e => {
      e.preventDefault(); errEl.hidden = true; addBtn.disabled = true;
      try {
        const r = await fetch(A.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        const j = await r.json();
        if (!r.ok) { errEl.textContent = j.description || j.message || 'Impossible d’ajouter ce produit.'; errEl.hidden = false; }
        else { await refreshCart(); toast(T.added); openCart(); }
      } catch (err) { form.submit(); }
      addBtn.disabled = false;
    });
    update();
  }

  /* ---------- Motion ---------- */
  function splitWords(el) {
    if (el.dataset.done) return; el.dataset.done = 1;
    let i = 0;
    const walk = node => Array.from(node.childNodes).forEach(n => {
      if (n.nodeType === 3) {
        const f = document.createDocumentFragment();
        n.textContent.split(/(\s+)/).forEach(t => {
          if (!t) return;
          if (/^\s+$/.test(t)) { f.appendChild(document.createTextNode(' ')); return; }
          const w = document.createElement('span'); w.className = 'wd';
          const s = document.createElement('span'); s.textContent = t; s.style.setProperty('--d', (i++ * 0.07) + 's');
          w.appendChild(s); f.appendChild(w);
        });
        n.replaceWith(f);
      } else if (n.nodeType === 1 && n.tagName !== 'BR') walk(n);
    });
    walk(el);
  }
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver(es => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }), { threshold: 0.15 })
    : { observe: el => el.classList.add('in') };

  function initMotion() {
    $$('.split').forEach(splitWords);
    const hero = $('#heroTitle'); if (hero) setTimeout(() => hero.classList.add('in'), 250);
    $$('.split:not(#heroTitle), .stag, .reveal, #word').forEach(el => io.observe(el));

    const big = $('#bigTxt');
    if (big) {
      const walk = node => Array.from(node.childNodes).forEach(n => {
        if (n.nodeType === 3) { const f = document.createDocumentFragment(); n.textContent.split(/(\s+)/).forEach(t => { if (!t) return; if (/^\s+$/.test(t)) { f.appendChild(document.createTextNode(t)); return; } const s = document.createElement('span'); s.className = 'tw'; s.textContent = t; f.appendChild(s); }); n.replaceWith(f); }
        else if (n.nodeType === 1) walk(n);
      });
      walk(big);
    }
    const word = $('#word');
    if (word && !word.querySelector('.brand-logo')) {
      const txt = word.childNodes[0] ? word.childNodes[0].textContent : '';
      let i = 0;
      word.innerHTML = Array.from(txt).map(c => `<span class="l" style="--i:${i++}">${esc(c)}</span>`).join('') + `<i class="l" style="--i:${i}">.</i>`;
    }
  }

  let lastY = window.scrollY, vel = 0, mx = 0;
  function frame() {
    const y = window.scrollY; vel = vel * 0.9 + (y - lastY) * 0.1; lastY = y;
    const vh = window.innerHeight;
    const m = $('#marq');
    if (m && !RM) { mx -= 0.6 + Math.min(Math.abs(vel) * 0.35, 14); const w = m.scrollWidth / 3; if (w && -mx >= w) mx += w; m.style.transform = `translate3d(${mx}px,0,0)`; }
    if (!RM) $$('.par').forEach(el => { const r = el.getBoundingClientRect(); if (r.bottom < 0 || r.top > vh) return; el.style.setProperty('--py', (((r.top + r.height / 2 - vh / 2) / vh) * -60).toFixed(1) + 'px'); });
    const big = $('#bigTxt');
    if (big) { const r = big.getBoundingClientRect(); const ws = $$('.tw', big); const p = RM ? 1 : Math.min(1, Math.max(0, (vh * 0.85 - r.top) / (r.height + vh * 0.35))); const n = Math.round(p * ws.length); ws.forEach((w, i) => w.classList.toggle('on', i < n)); }
    requestAnimationFrame(frame);
  }

  /* ---------- Événements ---------- */
  document.addEventListener('click', async e => {
    const t = e.target.closest('button, a'); if (!t) return;
    if (t.id === 'openCart' && drawer) { e.preventDefault(); await refreshCart(); return openCart(); }
    if (t.id === 'closeCart') return closeCart();
    if (t.id === 'openMenu') return $('#mnav').classList.add('open');
    if (t.id === 'closeMenu') return $('#mnav').classList.remove('open');
    if (t.hasAttribute('data-scroll')) { const el = $(t.getAttribute('href')); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: RM ? 'auto' : 'smooth' }); } return; }
    if (t.dataset.inc) { renderCart(await changeLine(t.dataset.inc, +t.dataset.q + 1)); return; }
    if (t.dataset.dec) { renderCart(await changeLine(t.dataset.dec, +t.dataset.q - 1)); return; }
    if (t.dataset.rm) { renderCart(await changeLine(t.dataset.rm, 0)); return; }
  });
  if (scrim) scrim.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); const mn = $('#mnav'); if (mn) mn.classList.remove('open'); } });
  document.addEventListener('change', e => {
    if (e.target.matches('[data-sort]')) { const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString(); }
  });
  document.addEventListener('mousemove', e => {
    const fl = $('#float'); if (!fl) return;
    const a = e.target.closest('.cats a[data-prev]');
    if (a) { const img = $('img', fl); if (img.getAttribute('src') !== a.dataset.prev) img.src = a.dataset.prev; fl.style.left = e.clientX + 'px'; fl.style.top = e.clientY + 'px'; fl.classList.add('on'); }
    else fl.classList.remove('on');
  });

  /* ---------- Démarrage ---------- */
  initMotion();
  initProduct();
  refreshCart();
  requestAnimationFrame(frame);
  // Éditeur de thème : relancer les animations quand une section est modifiée
  document.addEventListener('shopify:section:load', () => { initMotion(); initProduct(); });
})();

